type EventListeners = {
  [key: string]: ((data: any) => void)[];
};

const eventListeners: EventListeners = {};

export function emit(event: string, data: any): void {
  if (eventListeners[event]) {
    eventListeners[event].forEach((callback) => callback(data));
  }
}

export function on(event: string, callback: (data: any) => void): void {
  if (!eventListeners[event]) eventListeners[event] = [];
  eventListeners[event].push(callback);
}
